import React, { ReactElement } from 'react';

import displayValues from '../../../resources/displayValues.json';
import { ApiQueryParams } from '../../../interfaces';

export interface OriginDropdownProps {
    selectedValue: string;
    hideLabel?: boolean;
    triggerFetch: (queryParam?: ApiQueryParams) => void;
    filterChange: (newOriginAirportValue: string) => void;
}

interface Origin {
    value: string;
    text: string;
}

export const OriginDropdown: React.FC<OriginDropdownProps> = ({
    selectedValue,
    hideLabel = false,
    filterChange,
    triggerFetch,
}): ReactElement<OriginDropdownProps> => {
    const onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        filterChange(event.target.value);
        triggerFetch();
    };

    return (
        <div className="input input--select u-mt16">
            <label htmlFor="fromAirport" className={hideLabel ? 'u-screen-reader-only' : ''}>
                Reis fra
            </label>
            <div className="input--select__wrap">
                <select
                    value={selectedValue}
                    onChange={onChange}
                    id="origin"
                    aria-label="Avreisested"
                    onBlur={(): undefined => undefined}
                    data-testid="originDropdown">
                    {displayValues.originAirports.map((origin: Origin) => (
                        <option key={origin.value} value={origin.value}>
                            {origin.text}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
